import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './shared/auth';
import { ToastProvider } from './shared/components';
import { ThemeProvider } from './shared/theme';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* SPA served from root; Firebase Hosting rewrites all paths to /index.html */}
    <BrowserRouter>
      <AuthProvider>
        {/* ThemeProvider sits INSIDE AuthProvider because the theme choice is
            stored per employee_id — see the LAST_KEY note in shared/theme.tsx
            for how the pre-paint script covers the window before auth lands. */}
        <ThemeProvider>
          {/* Global Toast viewport. Components call useToast() to push messages. */}
          <ToastProvider>
            <App />
          </ToastProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
